<div class="modal-body">
  <table mat-table [dataSource]="dataSource" class="table">
    <ng-container matColumnDef="updateDate">
      <th mat-header-cell *matHeaderCellDef>DATE</th>
      <td mat-cell *matCellDef="let element">{{ element?.updateDate }}</td>
    </ng-container>

    <ng-container matColumnDef="updateTime">
      <th mat-header-cell *matHeaderCellDef>TIME</th>
      <td mat-cell *matCellDef="let element">{{ formatTimeWithSec(element?.updateTime?.toString()) }}</td>
    </ng-container>

    <ng-container matColumnDef="updateUser">
      <th mat-header-cell *matHeaderCellDef>USER</th>
      <td mat-cell *matCellDef="let element">{{ element?.updateUser }}</td>
    </ng-container>

    <ng-container matColumnDef="deleteYN">
      <th mat-header-cell *matHeaderCellDef>DELETE Y/N</th>
      <td mat-cell *matCellDef="let element">{{ element?.deleteYN }}</td>
    </ng-container>

    <ng-container matColumnDef="startDate">
      <th mat-header-cell *matHeaderCellDef>SCHEDULED DATE</th>
      <td mat-cell *matCellDef="let element">{{ element?.startDate }}</td>
    </ng-container>

    <ng-container matColumnDef="startTime">
      <th mat-header-cell *matHeaderCellDef>START TIME</th>
      <td mat-cell *matCellDef="let element">{{ formatTime(element.startTime?.toString()) }}</td>
    </ng-container>

    <ng-container matColumnDef="endTime">
      <th mat-header-cell *matHeaderCellDef>END TIME</th>
      <td mat-cell *matCellDef="let element">{{ formatTime(element?.endTime?.toString()) }}</td>
    </ng-container>

    <ng-container matColumnDef="scheduledHours">
      <th mat-header-cell *matHeaderCellDef>SCHEDULED HOURS</th>
      <td mat-cell *matCellDef="let element">{{ element?.scheduledHours }}</td>
    </ng-container>

    <ng-container matColumnDef="resourceList">
      <th mat-header-cell *matHeaderCellDef>RESOURCE LIST</th>
      <td mat-cell *matCellDef="let element">{{ element?.resourceList }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>DESCRIPTION</th>
      <td mat-cell *matCellDef="let element">{{ element?.description }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator #paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]"> </mat-paginator>
</div>
